export default {"src":"/_next/static/media/arrow.6937f067.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};